import { GET_POSITION_TYPES, GET_POSITION_TYPES_SUCCESS, GET_POSITION_TYPES_ERROR } from "./actionTypes";

const initialState = {
  errorGetPositionTypes: "",
  loadingGetPositionTypes: false,
  position_types: null,
  successGetPositionTypes: "",
};

const getPositionTypes = (state = initialState, action) => {
  switch (action.type) {
    case GET_POSITION_TYPES:
      state = {
        ...state,
        loadingGetPositionTypes: true,
      };
      break;
    case GET_POSITION_TYPES_SUCCESS:
      state = {
        ...state,
        loadingGetPositionTypes: false,
        position_types: action.payload.position_types,
        successGetPositionTypes: action.payload.message,
      };
      break;
    case GET_POSITION_TYPES_ERROR:
      state = { ...state, errorGetPositionTypes: action.payload, loadingGetPositionTypes: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getPositionTypes;
